define.alias("shared/components/shared/profile-avatar", "calendar/components/shared/profile-avatar");